import { useMemo, useState } from 'react'
import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  POSICOES: 'Calculando saldo das posições do estoque',
}

const INITIAL_STATE = {
  selectedEstoques: null,
  selectedCompanies: null,
  produtos: [],
  estoques: [],
  companies: [],
  globalFilter: '',
  checkpoint: new Date(),
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useRelatorioSaldoEstoque() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  function buildCompaniesList(produtos) {
    const uniques = []
    produtos.forEach(p => {
      if (!uniques.find(u => u.id === p.company)) uniques.push({ id: p.company, name: p.company })
    })
    return uniques.sort((a, b) => a.name.localeCompare(b.name))
  }

  const localDispatch = useMemo(() => {
    return {
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
          pathToRedirect: null,
        }))
      },

      getRelatorioSaldoEstoque(selectedTp, selectedEstoques, checkpoint) {
        if (!selectedEstoques || selectedEstoques.length === 0) {
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione pelo menos um estoque' }))
          return
        }

        EstoqueHttp.getRelatorioSaldoEstoque(
          selectedTp,
          selectedEstoques.map(e => e.id),
          checkpoint,
        )
          .then(res =>
            setState(prevState => ({
              ...prevState,
              produtos: res,
              companies: buildCompaniesList(res),
              selectedCompanies: null,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      onClickPesquisar() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.POSICOES }))
      },

      async onInit(selectedTp) {
        if (!selectedTp) {
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
          return
        }
        EstoqueHttp.getEstoques(selectedTp)
          .then(res =>
            setState(prevState => ({
              ...prevState,
              estoques: res,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      onChange(name, value) {
        setState(prevState => ({ ...prevState, [name]: value }))
      },
    }
  }, [])

  return { state, localDispatch }
}
